export default class InternationalizationService {
  static selectLanguages = [
    { text: "Português", value: "pt" },
    { text: "English", value: "en" }
  ];

  static selectCountryCodes = [
    { text: "Portugal", value: "PT" },
    { text: "Great Britain", value: "GB" },
    { text: "España", value: "ES" },
    { text: "Ireland", value: "IE" },
    { text: "France", value: "FR" },
    { text: "Netherlands", value: "NL" }
  ];

  static getDisplayStringFromValue(value: string): string {
    if (!value) return "No Language Selected";
    for (
      let i = 0;
      i < InternationalizationService.selectLanguages.length;
      i++
    ) {
      if (InternationalizationService.selectLanguages[i].value === value)
        return InternationalizationService.selectLanguages[i].text;
    }
    return "No Matching Language";
  }
}
